import { SHA256 } from "crypto-js";
// Function to calculate the hash of a file
export const calculateFileHash = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const fileData = reader.result;
      const wordArray = SHA256(fileData as string);
      const hash = wordArray.toString();
      resolve(hash);
    };

    reader.onerror = () => {
      reject(new Error("Error reading file"));
    };

    reader.readAsBinaryString(file);
  });
};
